<template>
  <div
    class="language"
    :class="{'language-active': activeStatus}"
    @click="changeActiveLanguage"
  >
    {{ languageProp }}
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "LanguageSwitcherElement",
  props: {
    languageProp: String
  },
  computed: {
    ...mapState([
        "language",
        "show"
    ]),
    activeStatus() {
      return this.language === this.languageProp
    },
  },
  methods: {
    ...mapMutations([
        "changeLanguage"
    ]),
    changeActiveLanguage() {
      if (this.show && this.language !== this.languageProp) {
        this.changeLanguage(this.languageProp)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/variables.scss";

.language {
  font-weight: bold;
  transition: 1s;
  cursor: pointer;
  &-active {
     color: $router-element-color;
   }
}
.app-dark-theme {
  .language {
    color: #ccc;
    &-active {
      color: white;
    }
  }
}

</style>